module.exports = __webpack_public_path__ + "img/icon_suprise.fe4d575b.svg";